import React from 'react';
import { CardContainer, Description, IconWrapper, InnerLayout, TextWrapper, Title } from './styles';

export interface FeatureOption {
  id: number;
  title: string;
  description: string;
  icon: React.ReactNode;
}

interface FeatureCardProps {
  item: FeatureOption;
  index: number;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({ item, index }) => {
  return (
    <CardContainer
      initial={{ y: 30, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1 }}
      whileHover={{
        y: -5,
        boxShadow: '0px 0.5rem 1.25rem 0px rgba(0,0,0,0.1)',
      }}
    >
      <InnerLayout>
        <IconWrapper>{item.icon}</IconWrapper>

        <TextWrapper>
          <Title>{item.title}</Title>
          <Description>{item.description}</Description>
        </TextWrapper>
      </InnerLayout>
    </CardContainer>
  );
};
